var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacyDirectDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9133 7.28499C28.6163 6.79253 28.1974 6.38491 27.6971 6.10144C27.1967 5.81798 26.6317 5.66823 26.0566 5.66666H22V2.33332C22 1.8913 21.8244 1.46737 21.5118 1.15481C21.1993 0.842252 20.7753 0.666656 20.3333 0.666656H3.66665C1.82831 0.666656 0.333313 2.16166 0.333313 3.99999V20.6667C0.333313 21.91 1.02665 22.985 2.03831 23.5567C2.24331 26.5883 4.74998 29 7.83331 29C10.765 29 13.1733 26.8183 13.5816 24H18.7516C19.16 26.8183 21.5683 29 24.5 29C27.4316 29 29.84 26.8183 30.2483 24H30.3333C32.1716 24 33.6666 22.505 33.6666 20.6667V15.6667C33.667 15.3642 33.5846 15.0673 33.4283 14.8083L28.9133 7.28499ZM22 8.99999H26.0566L29.0566 14H22V8.99999ZM7.83331 25.6667C6.45498 25.6667 5.33331 24.545 5.33331 23.1667C5.33331 21.7883 6.45498 20.6667 7.83331 20.6667C9.21165 20.6667 10.3333 21.7883 10.3333 23.1667C10.3333 24.545 9.21165 25.6667 7.83331 25.6667ZM24.5 25.6667C23.1216 25.6667 22 24.545 22 23.1667C22 21.7883 23.1216 20.6667 24.5 20.6667C25.8783 20.6667 27 21.7883 27 23.1667C27 24.545 25.8783 25.6667 24.5 25.6667Z",
    fill: "#008187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyDirectDelivery);
export default __webpack_public_path__ + "static/media/pharmacy-direct-delivery.5d88947c610066d41810c2cb3d7e85fa.svg";
export { ForwardRef as ReactComponent };